<header
    class="ap-header"
    [ngClass]="{
        'ap-header__border-bottom': !menuOpen(),
        'ap-header--standalone': variant() === 'standalone'
    }"
>
    <nav class="ap-header__canvas" [ngClass]="getCanvasModifier()">
        <ul class="ap-header__container">
            <li>
                @if (logoLink()) {
                    <a class="ap-header__logo-container" [href]="logoLink()" [attr.aria-label]="logoAriaLabel()">
                        <ap-illustration
                            [name]="'logo-' + theme"
                            [attr.aria-label]="logoAriaLabel()"
                            height="100%"
                            width="100%"
                            data-testid="header-illustration"
                        ></ap-illustration>
                    </a>
                }
                @if (!logoLink()) {
                    <div class="ap-header__logo-container">
                        <ap-illustration
                            [name]="'logo-' + theme"
                            [attr.aria-label]="logoAriaLabel()"
                            height="100%"
                            width="100%"
                            data-testid="header-illustration"
                        ></ap-illustration>
                    </div>
                }
            </li>
        </ul>

        @if (icon()) {
            <ap-icon [name]="icon()" [manualSize]="36" class="ap-header__icon"></ap-icon>
        } @else if (hasNavigationItems()) {
            <ap-hamburger
                class="ap-header__hamburger"
                [ngClass]="{ 'ap-header__hamburger--hide-on-tablet': !showHamburgerOnTablet() }"
                [isOpen]="menuOpen()"
                (toggleMenu)="toggleMenu()"
            >
                @if (getSearchItem()) {
                    <ap-search-icon [searchNavigationItem]="getSearchItem()" (searchClicked)="navigate($event)"> </ap-search-icon>
                }
                @if (isLoggedIn() && profileMenu()) {
                    <ap-action-icon
                        class="ap-header__navigation-icon"
                        [ariaLabel]="'header.profile.open' | apContent"
                        (onClick)="toggleProfileMenu()"
                        data-testid="mobile-user-button"
                    >
                        <ap-icon [name]="profileMenuOpen() ? 'close' : 'user'" size="large"> </ap-icon>
                        @if (profileMenu().notifications && !profileMenuOpen()) {
                            <ap-badge class="ap-header__badge" data-testid="header-horizontal-profile-notifications">{{
                                profileMenu().notifications
                            }}</ap-badge>
                        }
                    </ap-action-icon>
                }
            </ap-hamburger>

            <ap-horizontal-menu
                class="ap-header__navigation-container"
                [ngClass]="{
                    'ap-header__navigation-container--hide-on-tablet': showHamburgerOnTablet(),
                    'ap-header--standalone': variant() === 'standalone'
                }"
                [navigationItems]="navigationItems()"
                [isLoggedIn]="isLoggedIn()"
                [profileMenu]="profileMenu()"
                (navigationClicked)="navigate($event)"
                (profileItemClicked)="navigateProfileMenu($event)"
                (loginLogout)="loginLogout.emit($event)"
                data-testid="header-horizontal-menu"
            >
            </ap-horizontal-menu>
        }
    </nav>
    @if (!icon()) {
        @if (menuOpen()) {
            <ap-vertical-menu
                [@rollDownUp]
                class="ap-header__vertical-menu"
                [ngClass]="{ 'is-active': menuOpen() }"
                [navigationItems]="navigationItems()"
                [isLoggedIn]="isLoggedIn()"
                (navigationClicked)="navigate($event)"
                (loginLogout)="loginLogout.emit($event)"
            ></ap-vertical-menu>
        }
        @if (profileMenuOpen()) {
            <ap-profile-menu
                class="ap-header__vertical-menu"
                [ngClass]="{ 'is-active': profileMenuOpen() }"
                [profileMenu]="profileMenu()"
                (loginLogout)="loginLogout.emit($event)"
                (itemClicked)="navigateProfileMenu($event)"
            >
            </ap-profile-menu>
        }
    }
</header>
